<div class="clients-container p-3">
	<mat-card class="p-4 h-100">
		<mat-card-header>
			<mat-card-title class="d-flex justify-content-between align-items-start w-100">
				<app-nav-map></app-nav-map>
				@if(apiLoading) {
				<mat-spinner diameter="16" class="mt-2 ms-2"></mat-spinner>
				}

				<button
					mat-stroked-button
					color="warn"
					class="d-flex justify-content-center ms-auto align-items-center me-1"
					matTooltip="{{ 'CLIENT.MANUAL_JSON_PASTE' | translate }} -- Developer Мode --"
					matTooltipPosition="below"
					(click)="itemAction('CLIENT', 'DEV_MODE')">
					<mat-icon class="m-0">data_object</mat-icon>
				</button>

				<button mat-flat-button color="primary" class="d-flex justify-content-center align-items-center me-1" (click)="itemAction('CLIENT', 'NEW')">
					{{ 'BUTTON.CREATE' | translate }} {{ 'CLIENT.TITLE' | translate }}
				</button>

				<button mat-stroked-button type="button" color="primary" (click)="itemAction('CLIENT', 'SEND_REPORTS')" [disabled]="!selectedClients.length">
					{{ 'CLIENT.SEND_REPORTS' | translate }}
				</button>
			</mat-card-title>
		</mat-card-header>

		<mat-divider class="w-75 mb-4"></mat-divider>

		<div class="row">
			<!-- CLIENT Managment -->
			<div class="col">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'BUTTON.SEARCH' | translate }}</mat-label>
					<input matInput type="text" [formControl]="searchFormControl" />
					<mat-icon class="cursor-pointer" matSuffix>search</mat-icon>
				</mat-form-field>

				<div class="mat-elevation-z2 px-0">
					<table id="clients-table" mat-table [dataSource]="dataSourceClient">
						@for (column of displayedColumnsClient; track $index) {
						<ng-container [matColumnDef]="column">
							<th mat-header-cell *matHeaderCellDef>
								@switch (column) { @case ('SELECTION') {
								<div class="d-flex align-items-center">
									<mat-checkbox
										color="primary"
										[checked]="selectedClients.length === dataSourceClient.data.length"
										[indeterminate]="selectedClients.length > 0 && selectedClients.length !== dataSourceClient.data.length"
										(change)="selectAllClients($event)">
									</mat-checkbox>
									@if (selectedClients.length > 0) {
									<span class="ms-2 font-weight-bold text-primary">{{ selectedClients.length }}</span>
									}
								</div>
								} @case ('LAST_REPORT_SENT_AT') {
								<mat-select
									class="table-filter-select"
									[formControl]="sortReportSentAt"
									(selectionChange)="getClients()"
									matTooltip="{{ 'CLIENT.LAST_REPORT_SENT_AT' | translate }}"
									matTooltipPosition="below">
									<mat-option [value]="'CLIPPING'">{{ 'CLIENT.CLIPPING' | translate }}</mat-option>
									<mat-option [value]="'BUSINESS_INFORMATOR'">{{ 'CLIENT.BUSINESS_INFORMATOR' | translate }}</mat-option>
								</mat-select>
								} @case ('ACTIONS') { } @case ('SUBSCRIPTIONS') {
								<mat-select class="table-filter-select" [formControl]="filterSubscriptionType" multiple>
									<mat-select-trigger>
										{{
											filterSubscriptionType.value?.length === 1
												? ('CLIENT.' + filterSubscriptionType.value[0] | translate)
												: filterSubscriptionType.value.length === subscriptionsFilterOptions.length + 1
												? ('CLIENT.ALL' | translate)
												: filterSubscriptionType.value?.length > 1
												? ('CLIENT.' + filterSubscriptionType.value[0] | translate) + ' + ' + filterSubscriptionType.value.length
												: ('ASSORTED.SELECT_OPTION' | translate)
										}}
									</mat-select-trigger>

									<!-- <mat-option #selectAllSubscriptions [value]="'ALL'" (click)="getClients(undefined, 'ALL')"
										>{{ 'CLIENT.SUBSCRIPTIONS' | translate }}: {{ 'ASSORTED.ALL' | translate }}
									</mat-option> -->

									@for (option of subscriptionsFilterOptions; track $index) {
									<mat-option [value]="option" (click)="getClients(undefined, $event)">{{ 'CLIENT.SUBSCRIPTIONS' | translate }}: {{ 'CLIENT.' + option | translate }}</mat-option>
									}
								</mat-select>
								} @default {
								{{ 'CLIENT.' + column | translate }}
								} }
							</th>
							<td mat-cell *matCellDef="let element" [ngClass]="{ selected: selectedClient && selectedClient.id === element['id'] }">
								@switch (column) { @case('SELECTION') {
								<mat-checkbox color="primary" [(ngModel)]="element.checked" (change)="checkItemClient($event, element)"></mat-checkbox>
								} @case ('LAST_REPORT_SENT_AT') { @if(element.lastClippingReportSentAt) {
								<div class="d-flex flex-wrap">
									<span class="w-100 font smaller">
										<strong>{{ 'CLIENT.SUBSCRIPTION_TYPES.CLIPPING' | translate }}:</strong>
									</span>
									<span class="font smaller">{{ utils.formatDate(element.lastClippingReportSentAt, true) }}</span>
								</div>
								} @if(element.lastBiReportSentAt) {
								<div class="d-flex flex-wrap">
									<span class="w-100 font smaller">
										<strong>{{ 'CLIENT.BUSINESS_INFORMATOR' | translate }}:</strong>
									</span>
									<span class="font smaller">{{ utils.formatDate(element.lastBiReportSentAt, true) }}</span>
								</div>
								} } @case ('LANG') {
								<div class="d-flex w-100 justify-content-center pt-2">
									<img [src]="externalAssets + '/flags/' + element[column.toLowerCase()].toLowerCase() + '.svg'" width="22px" alt="" />
								</div>
								} @case ('ACTIONS') {
								<div class="d-flex justify-content-end">
									@if (element.pendingTagsSubscriptionsJson || element.pendingInvoiceJson) {
									<button
										mat-icon-button
										color="primary"
										class="me-1 subscription-request-button"
										aria-label="Subscription request"
										matTooltip="{{ 'CLIENT.SUBSCRIPTION_REQUESTS' | translate }}"
										matTooltipPosition="below"
										(click)="itemAction('CLIENT', 'DEV_MODE', element)">
										<mat-icon>pending_actions</mat-icon>
									</button>
									}

									<button
										class="send-report-button"
										mat-icon-button
										color="primary"
										class="me-1"
										aria-label="Additional configuration"
										matTooltip="{{ 'BUTTON.SEND' | translate }}"
										matTooltipPosition="below"
										(click)="itemAction('CLIENT', 'SEND_REPORT', element)">
										<mat-icon>outgoing_mail</mat-icon>
									</button>

									<button
										mat-icon-button
										class="me-1 export-button"
										aria-label="Export report"
										matTooltip="{{ 'BUTTON.EXPORT' | translate }}"
										matTooltipPosition="below"
										(click)="itemAction('CLIENT', 'EXPORT_REPORT', element)">
										<mat-icon>download</mat-icon>
									</button>

									<button
										mat-icon-button
										class="me-1 subscriptions-button"
										aria-label="Additional configuration"
										matTooltip="{{ 'CLIENT.SUBSCRIPTIONS' | translate }}"
										matTooltipPosition="below"
										(click)="itemAction('CLIENT', 'DETAILS', element)">
										<mat-icon>task</mat-icon>
									</button>

									<button mat-icon-button class="more-options-button ms-3 me-1" [matMenuTriggerFor]="menu" aria-label="edit or delete menu client">
										<mat-icon>more_vert</mat-icon>
									</button>
									<mat-menu class="more-options-menu" #menu="matMenu">
										<button mat-menu-item (click)="itemAction('CLIENT', 'EDIT', element)">
											<span class="pe-2">{{ 'BUTTON.EDIT' | translate }}</span>
											<mat-icon>edit</mat-icon>
										</button>
										<button mat-menu-item (click)="itemAction('CLIENT', 'DELETE', element)">
											<span class="pe-2">{{ 'BUTTON.DELETE' | translate }}</span>
											<mat-icon class="warn">close</mat-icon>
										</button>
									</mat-menu>
								</div>

								} @case ('SUBSCRIPTIONS') {
								<div class="d-flex flex-wrap">
									@for(subscription of element[column.toLowerCase()]; track $index) {
									<span class="subscription-span me-1 mt-1 font smaller" [style.color]="getSubscriptionValidityStatus(subscription.validTo)">
										{{ 'CLIENT.SUBSCRIPTION_TYPES.' + subscription.type | translate }}({{ utils.formatDate(subscription.validTo) }})
									</span>
									}
								</div>
								} @default {
								<span class="font strong">{{ element[column.toLowerCase()] }}</span>
								} }
							</td>
						</ng-container>
						}
						<tr mat-header-row *matHeaderRowDef="displayedColumnsClient; sticky: true"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumnsClient"></tr>
					</table>

					<mat-paginator [pageSizeOptions]="PAGE_OPTIONS" [pageSize]="PAGE_OPTIONS[0]" (page)="getClients()" showFirstLastButtons aria-label="Select page of users">
					</mat-paginator>
				</div>
			</div>
			<!-- (END)CLIENT Managment -->

			@if(selectedClient) {
			<div class="col">
				<!-- SUBSCRIPTIONS Management -->
				<div class="row mb-2">
					<div class="d-flex align-items-center justify-content-between">
						<button
							class="mb-1"
							mat-mini-fab
							color="primary"
							aria-label="Close subscriptions details"
							matTooltip="{{ 'CLIENT.DESELECT' | translate }}"
							matTooltipPosition="below"
							(click)="selectedClient = undefined">
							<mat-icon>arrow_back</mat-icon>
						</button>

						<h6>
							<span>{{ 'CLIENT.SUBSCRIPTIONS' | translate }}</span>
						</h6>

						<button
							class="mb-1"
							mat-mini-fab
							color="primary"
							aria-label="Add subscription"
							matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'CLIENT.SUBSCRIPTION' | translate }}"
							matTooltipPosition="below"
							(click)="itemAction('SUBSCRIPTION', 'NEW', selectedClient)"
							[disabled]="dataSourceSubscription.data.length === subscriptionTypes.length">
							<mat-icon>add</mat-icon>
						</button>
					</div>

					<div class="mat-elevation-z2 px-0">
						<table mat-table [dataSource]="dataSourceSubscription">
							@for (column of displayedColumnsSubscription; track $index) {
							<ng-container [matColumnDef]="column">
								<th mat-header-cell *matHeaderCellDef>
									@switch (column) { @case ('ACTIONS') {} @default {
									{{ 'CLIENT.' + column | translate }}
									} }
								</th>
								<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="itemAction('SUBSCRIPTION', 'EDIT', selectedClient, element)">
									@switch (column) { @case ('TYPE') {
									{{ 'CLIENT.SUBSCRIPTION_TYPES.' + element['type'] | translate }}
									} @case ('EMAIL_TO') { @for(email of element['emailTo']; track $index) {
									{{ email }} <br />
									} } @case ('VALID_FROM') {
									{{ utils.formatDate(element['validFrom']) }}
									}@case ('VALID_TO') {
									{{ utils.formatDate(element['validTo']) }}
									}@case ('ACTIONS') {
									<button
										mat-icon-button
										color="warn"
										aria-label="Delete subscription"
										matTooltip="{{ 'BUTTON.DELETE' | translate }}"
										matTooltipPosition="below"
										(click)="itemAction('SUBSCRIPTION', 'DELETE', element)">
										<mat-icon>close</mat-icon>
									</button>
									} }
								</td>
							</ng-container>
							}
							<tr mat-header-row *matHeaderRowDef="displayedColumnsSubscription; sticky: true"></tr>
							<tr mat-row *matRowDef="let row; columns: displayedColumnsSubscription" matTooltip="{{ 'ASSORTED.CLICK_TO_EDIT' | translate }}" matTooltipPosition="below"></tr>
						</table>
					</div>
				</div>
				<!-- (END)SUBSCRIPTIONS Management -->

				<!-- ACCOUNTS Management -->
				<div class="row">
					<div class="d-flex align-items-center justify-content-between">
						<h6 class="flex-fill text-center ms-4">
							<span>{{ 'CLIENT.ACCOUNTS' | translate }}</span>
						</h6>

						<button
							class="mb-1"
							mat-mini-fab
							color="primary"
							aria-label="Add account"
							matTooltip="{{ 'BUTTON.CREATE' | translate }} {{ 'CLIENT.ACCOUNT' | translate }}"
							matTooltipPosition="below"
							(click)="itemAction('ACCOUNT', 'NEW', selectedClient)">
							<mat-icon>add</mat-icon>
						</button>
					</div>

					<div class="mat-elevation-z2 px-0">
						<table mat-table [dataSource]="dataSourceAccounts">
							@for (column of displayedColumnsAccounts; track $index) {
							<ng-container [matColumnDef]="column">
								<th mat-header-cell *matHeaderCellDef>
									{{ 'CLIENT.' + column | translate }}
								</th>
								<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="itemAction('ACCOUNT', 'EDIT', selectedClient, element)">
									@switch (column) { @case ('SHOW_TAGS') {
									{{ 'ASSORTED.' + (element['showTags'] ? 'YES' : 'NO') | translate }}
									} @case ('SCOPES') { @for(scope of sortScopes(element[column.toLowerCase()]); track $index) {
									{{ 'ROLE.' + scope.toUpperCase() | translate }} {{ $last ? '' : '|' }} }} @case ('ACTIVE') {
									<div class="d-flex justify-content-end">
										@if(element.active) {
										<button
											mat-icon-button
											color="warn"
											aria-label="Deactivate data item"
											matTooltip="{{ 'BUTTON.DEACTIVATE' | translate }}"
											matTooltipPosition="below"
											(click)="itemAction('ACCOUNT', 'DEACTIVATE', selectedClient, element)">
											<mat-icon>person_remove</mat-icon>
										</button>
										} @else {
										<button
											mat-icon-button
											class="activate me-1"
											aria-label="Activate data item"
											matTooltip="{{ 'BUTTON.ACTIVATE' | translate }}"
											matTooltipPosition="below"
											(click)="itemAction('ACCOUNT', 'ACTIVATE', selectedClient, element)">
											<mat-icon>person_add</mat-icon>
										</button>
										} @if(!element.active) {
										<button
											mat-icon-button
											color="warn"
											aria-label="Delete data item"
											matTooltip="{{ 'BUTTON.DELETE' | translate }}"
											matTooltipPosition="below"
											(click)="itemAction('ACCOUNT', 'DELETE', selectedClient, element)">
											<mat-icon>close</mat-icon>
										</button>
										}
									</div>
									} @default {
									{{ element[column.toLowerCase()] }}
									} }
								</td>
							</ng-container>
							}
							<tr mat-header-row *matHeaderRowDef="displayedColumnsAccounts; sticky: true"></tr>
							<tr mat-row *matRowDef="let row; columns: displayedColumnsAccounts" matTooltip="{{ 'ASSORTED.CLICK_TO_EDIT' | translate }}" matTooltipPosition="below"></tr>
						</table>

						<mat-paginator
							[pageSizeOptions]="[ACCOUNTS_PAGE_SIZE]"
							[pageSize]="ACCOUNTS_PAGE_SIZE"
							(page)="getClientAccounts()"
							showFirstLastButtons
							aria-label="Select page of users">
						</mat-paginator>
					</div>
				</div>
				<!-- (END)ACCOUNTS Management -->
			</div>
			}
		</div>
	</mat-card>
</div>
